module.exports = __webpack_public_path__ + "img/huang.d6f05e15.png";